"use client";
import React from "react";
import "./Specialization_Fee_Curriculum.css";

const Specialization_Fee_Curriculum = () => {
  return (
    <section className="fees" id="fees">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 ">

            <h2 className="text-center text-white mt-0 mb-2">
              Fees & Curriculum
            </h2>

            <div className="table-responsive rounded-3">
              <table className="table custom-table text-center align-middle">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Total Fee</th>
                    <th>Semester 1</th>
                    <th>Semester 2</th>
                    <th>Semester 3</th>
                    <th>Semester 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>Indian Civilian</th>
                    <td>₹1,40,000/-</td>
                    <td>₹40,000</td>
                    <td>₹40,000</td>
                    <td>₹30,000</td>
                    <td>₹30,000</td>
                  </tr>
                  <tr>
                    <th>International Students</th>
                    <td>US$ 2,700</td>
                    <td>US$ 750</td>
                    <td>US$ 750</td>
                    <td>US$ 600</td>
                    <td>US$ 600</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="fees-note text-white">
              <strong>Note:-</strong>
              <br />
              Concessions in fees are available in the following cases-
              <br />
              A scholarship of Rs 10,000/- will be offered at payment of full fee
              in single or two transactions within 15 days
              <br />
              No Cost EMI
              <br />
              *For details, please contact the admission cell.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Specialization_Fee_Curriculum;